import i18n from '@/libs/i18n/index'
import useEntityCrud from '@/composable/useEntityCrud'
import useEntityHelper from '@/composable/useEntityHelper'
import useErrorManager from '@/composable/useErrorManager'

export default function useCommentList() {
  const MODULE_NAME = 'page-categories'
  const ENDPOINT = 'page-categories'

  const errorManager = useErrorManager()
  const { getAlt } = useEntityHelper()
  function convertResource(resource, selectedLang) {
    return {
      ...resource,
      title: resource.title[selectedLang],
      keywords: resource.keywords && resource.keywords[selectedLang] ? resource.keywords[selectedLang] : '',
      description: resource.description[selectedLang],
      lang: selectedLang,
      user: resource.userId,
      pageCatThumbnail: resource.pageCatThumbnailFileId,
      pageCatCoverImage: resource.pageCatCoverImageFileId,
      pageCatThumbnailAlt: getAlt('pageCatThumbnailFileId', resource, selectedLang),
      pageCatCoverImageAlt: getAlt('pageCatCoverImageFileId', resource, selectedLang),
      pageCategoryLink: { name: 'pages-page-categories-edit', params: { id: resource._id, lang: selectedLang } },
    }
  }
  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)

  // Table Handlers
  const tableColumns = [
    {
      key: 'title', label: i18n.t('general.title'), type: 'textImage', textKey: 'title', imageKey: 'pageCatThumbnail', linkKey: 'pageCategoryLink', sortable: true,
    },
    { key: 'slug', label: i18n.t('general.slug'), sortable: true },
    {
      key: 'pageCatCoverImage', label: i18n.t('general.cover'), sortable: false, type: 'image',
    },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), sortable: true, type: 'dateTime',
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), sortable: true, type: 'dateTime',
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  return {
    ...entity,
    convertResource,
    errorManager,
    tableColumns,
  }
}
